import Snackbar from "@mui/material/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router";
import { useState, useEffect } from "react";

import {
  getSettingState,
  setSnackbarMode,
} from "../../../redux/features/settingSlice";
import { getPlayerState } from "../../../redux/features/playerSlice";

const SnackBar = () => {
  const { snackbarMode, snackbarTitle } = useSelector(getSettingState);
  const { minimizePlayer } = useSelector(getPlayerState);
  const dispatch = useDispatch();
  const location = useLocation();
  let urlParams = location.pathname.split("/");
  const [bottomHeight, setBottomHeight] = useState(154);
  // if topic page

  useEffect(() => {
    if (urlParams[1] === "opinions" && !!urlParams[3]) {
      setBottomHeight(154);
    } else {
      if (minimizePlayer) {
        setBottomHeight(162);
      } else {
        setBottomHeight(82);
      }
    }
    if (urlParams.slice(-1)[0] === "comment") {
      setBottomHeight(100);
    }
  }, [minimizePlayer, urlParams]);

  const closeIcon = (
    <>
      <IconButton
        size='small'
        aria-label='close'
        color='inherit'
        onClick={() => dispatch(setSnackbarMode(false))}
        sx={{ padding: "0 4px 5px 4px" }}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
    </>
  );

  return (
    <Snackbar
      sx={{
        left: "18px !IMPORTANT",
        right: "18px !IMPORTANT",
        bottom: `${bottomHeight}px !IMPORTANT`,
        height: "48px IMPORTANT",

        "& > div": {
          fontSize: "16px",
          backgroundColor: "gray.main",
          width: "100%",
          padding: "8px 16px 4px 16px",
          borderRadius: "8px",
        },
      }}
      vertical='top'
      horizontal='center'
      open={snackbarMode}
      onClose={() => dispatch(setSnackbarMode(false))}
      autoHideDuration={2800}
      message={snackbarTitle}
      action={closeIcon}
      // key={vertical + horizontal}
    />
  );
};
export default SnackBar;
